module.exports = __webpack_public_path__ + "img/systrarna-pa-naset.5d61965a.jpg";